"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Modal = require("./Modal.styles");

var _Field = _interopRequireDefault(require("../Field/Field"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CopyField = function CopyField(_ref) {
  var copyText = _ref.copyText,
      duration = _ref.duration,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["copyText", "duration"]);
  return (0, _jsxRuntime.jsx)(_Field["default"], _objectSpread({
    showCopy: true,
    readOnly: true,
    copyText: copyText,
    copyDuration: duration,
    css: _Modal.styles.copyField
  }, otherProps));
};

CopyField.propTypes = {
  copyText: _propTypes.string,
  duration: _propTypes.number
};
CopyField.defaultProps = {
  copyText: 'Copy',
  duration: 2000
};
var _default = CopyField;
exports["default"] = _default;
//# sourceMappingURL=CopyField.js.map